import React, { useMemo, useState } from "react";
import { useFilterJobs } from "@/providers/contexts";
import { JobPost } from "@/types/jobPost";
import dayjs from "dayjs";

export const useSearchPageLogic = () => {
  /* --------------------- Hooks --------------------- */

  const {
    noMatchingResults,
    getNoResultsMessage,
    jobPosts,
    resetFilters,
    loading,
    error,
    pagination,
    page,
    setPage,
  } = useFilterJobs();

  /* --------------------- States --------------------- */

  const [sortAscending, setSortAscending] = useState<boolean | null>(null);

  /* --------------------- Handles --------------------- */

  const handlePageChange = (_: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
  };

  const resetAndHandlePageChange = () => {
    resetFilters();
    setPage(1);
    setSortAscending(null);
  };

  const sortedJobPosts = useMemo(() => {
    if (sortAscending === null) return jobPosts;

    return [...jobPosts].sort((a: JobPost, b: JobPost) => {
      const dateA = dayjs(a.job_posted);
      const dateB = dayjs(b.job_posted);

      return sortAscending ? dateA.diff(dateB) : dateB.diff(dateA);
    });
  }, [jobPosts, sortAscending]);

  const onSortByDate = (isAscending: boolean) => {
    setSortAscending(isAscending);
    setPage(1);
  };

  return {
    resetAndHandlePageChange,
    jobPosts: sortedJobPosts,
    totalPages: pagination.totalPages,
    currentPage: page,
    handlePageChange,

    noMatchingResults,
    getNoResultsMessage,
    resetFilters,
    loading,
    error,

    onSortByDate,
    sortAscending,
  };
};
